// Mirrors backend PERMISSION_MAP. Used purely for UI gating (hide buttons,
// show "view-only" hints). The backend re-checks every mutation.

const PERMISSION_MAP = {
  owner: new Set(['*']),
  admin: new Set([
    'events.*', 'photographers.*', 'gear.*', 'plans.*', 'spots.*',
    'courses.*', 'timings.*', 'image_library.*', 'content_templates.*',
    'chat.*', 'team.manage', 'share.*',
    'clients.*', 'quotes.*', 'proposals.*', 'invoices.*',
    'timesheets.*', 'reports.view',
  ]),
  editor: new Set([
    'events.view', 'events.edit',
    'photographers.view', 'photographers.edit',
    'gear.view', 'gear.edit',
    'plans.view', 'plans.edit',
    'spots.view', 'spots.edit',
    'courses.view', 'courses.edit',
    'timings.view', 'timings.edit',
    'image_library.view', 'image_library.edit',
    'content_templates.view', 'content_templates.edit',
    'chat.send', 'chat.view',
    'share.create',
    'clients.view',
    'quotes.view', 'quotes.edit',
    'proposals.view', 'proposals.edit',
    'invoices.view', 'invoices.edit',
    'timesheets.view', 'timesheets.edit',
    'reports.view',
  ]),
  viewer: new Set([
    'events.view', 'photographers.view', 'gear.view', 'plans.view',
    'spots.view', 'courses.view', 'timings.view',
    'image_library.view', 'content_templates.view',
    'chat.view',
    'clients.view', 'quotes.view', 'proposals.view',
    'invoices.view', 'timesheets.view', 'reports.view',
  ]),
  // Scoped role for image editors / retouchers — only the high-res photo
  // gallery within events.
  photo_editor: new Set([
    'events.view',
    'spots.photos.view',
    'spots.photos.delete',
  ]),
};

export function teamRoleOf(user) {
  if (!user) return 'viewer';
  if (user.role === 'admin') return 'owner';
  return user.team_role || 'owner';
}

export function hasPermission(user, action) {
  const role = teamRoleOf(user);
  const perms = PERMISSION_MAP[role] || new Set();
  if (perms.has('*') || perms.has(action)) return true;
  const [resource] = action.split('.');
  return perms.has(`${resource}.*`);
}

export function canEdit(user, resource) {
  return hasPermission(user, `${resource}.edit`);
}

export function canManageTeam(user) {
  return hasPermission(user, 'team.manage');
}

export function isPhotoEditor(user) {
  return teamRoleOf(user) === 'photo_editor';
}

export function canViewPhotos(user) {
  return hasPermission(user, 'spots.view') || hasPermission(user, 'spots.photos.view');
}
